import React, { useState } from 'react';
import { Link } from 'react-router-dom';
import './button.style.scss';
import { __ButtonProps, __ButtonTypes } from './button.interface';
import { Spinner } from 'react-bootstrap';
export const SLPButtonTypes = __ButtonTypes;

const SLPButton: React.FC<__ButtonProps> = function (props: __ButtonProps) {
    const [loading, setLoading] = useState<boolean>(false);
    const providedProps = {
        style: props.style,
        className: `UCheck-SLP-button button-primary ${props.className} ${loading ? 'button-loading' : ''} ${
            props.type ? props.type : __ButtonTypes.filled
        } ${props.disabled ? 'disabled' : ''}`,
        onClick: onClickHandler,
    };

    function onClickHandler(e: any) {
        if (props.disabled) {
            e.preventDefault();
        } else if (props.onClick) {
            const returned = props.onClick();
            if (returned) {
                setLoading(true);
                returned.then(() => {
                    setLoading(false);
                });
            }
        }
    }

    function content() {
        return (
            <>
                {props.children}
                {loading && (
                    <span className="button-loader">
                        <Spinner animation="border" size="sm" variant="light" />
                    </span>
                )}
            </>
        );
    }
    if (props.href) {
        return (
            <Link {...providedProps} to={props.href}>
                {content()}
            </Link>
        );
    }
    return <button {...providedProps}>{content()}</button>;
};

export default SLPButton;
